import { Injectable } from '@angular/core';

import { UserGroup } from 'src/models/user-groups';

import { GenericObjectsService } from './generic-objects.service';

@Injectable({
  providedIn: 'root',
})
export class UserGroupsService extends GenericObjectsService<UserGroup> {
  protected baseUrl = '/user-groups';

  // Similar to BE canSyncUserGroupToSlack
  // Note: Frontend version is simplified since we don't have database access
  // The backend will perform the full validation including checking managedByUnthread
  canSyncToSlack(userGroup?: UserGroup): boolean {
    const { sourceId, filters, targetId } = userGroup || {};

    if (!!sourceId && sourceId === targetId) {
      return false;
    }

    const slackGroupFilters = filters?.filter((filter: any) => filter.field === 'slackGroups.id');

    if (slackGroupFilters?.some((filter: any) => filter.value?.includes(targetId))) {
      return false;
    }

    return true;
  }
}
